import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { variableTranslations } from '../../constants/variableTranslations';
import { DataTable as SharedDataTable } from '../data-display';

const DataTable = ({
    userData = {},
    attributeKeys = [],
    attributeLabel = null
}) => {
    const { t } = useTranslation();

    const rows = useMemo(() => {
        return attributeKeys
            .map(key => {
                const userEntry = userData?.[key] || {};
                const hasVASValue = userEntry.VASValue !== undefined && userEntry.VASValue > 0;
                const hasPresence = userEntry.isPresent === true;

                if (!hasVASValue && !hasPresence) return null;

                const isTranslatable = variableTranslations.hasOwnProperty(userEntry.attributeName);
                const attributeName = userEntry.attributeName
                    ? (isTranslatable ? t(variableTranslations[userEntry.attributeName]) : userEntry.attributeName)
                    : t(variableTranslations[key] || key);

                const userRating = hasVASValue
                    ? `${userEntry.VASValue}/100`
                    : hasPresence
                        ? t('yes')
                        : '-';

                const userComment = userEntry?.attributeComment ?? '-';

                return {
                    attribute: attributeName,
                    userComment,
                    userRating,
                };
            })
            .filter(Boolean);
    }, [attributeKeys, t, userData]);

    const columns = useMemo(() => [
        {
            key: 'attribute',
            label: attributeLabel || t('attribute'),
            width: '33%',
        },
        {
            key: 'userRating',
            label: t('your_rating'),
            width: '33%',
        },
        {
            key: 'userComment',
            label: t('your_comment'),
            width: '33%',
        },
    ], [attributeLabel, t]);

    return (
        <SharedDataTable
            columns={columns}
            emptyMessage={t('no_data_available')}
            rowKey={(row, index) => `${row.attribute}-${index}`}
            rows={rows}
        />
    );
};

export default DataTable;
